<form class="form w-100 p-10" novalidate="novalidate" id="kt_login_signup_form" [formGroup]="registrationForm"
  (ngSubmit)="submit()">
  <!--begin::Heading-->
  <div class="text-center mb-11">
    <!--begin::Title-->
    <h1 class="text-dark fw-bolder mb-3">
   تسجيل الحساب
    </h1>
    <!--end::Title-->

    <!--begin::Subtitle-->

    <!--end::Subtitle--->
  </div>
  <!--begin::Heading-->

  <!--begin::Login options-->

  <!--end::Login options-->

  <!--begin::Separator-->

  <!--end::Separator-->

  <!-- begin::Alert error-->
  <ng-container *ngIf="hasError">
    <div class="mb-lg-15 alert alert-danger">
      <div class="alert-text font-weight-bold">
      بيانات التسجيل غير صحيحة
      </div>
    </div>
  </ng-container>
  <!-- end::Alert error-->

  <!--begin::Form group-->
  <div class="fv-row mb-8">
    <label class="form-label fw-bolder text-dark fs-6">الاسم الكامل</label>
    <input class="form-control bg-transparent" type="text" name="name" formControlName="name"   style="height: 45px;"
      placeholder="name" autocomplete="off" [ngClass]="{
        'is-invalid': registrationForm.controls['name'].invalid,
        'is-valid': registrationForm.controls['name'].valid
      }" />
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'name is required',
        control: registrationForm.controls['name']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'name should have at least 3 symbols',
        control: registrationForm.controls['name']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'name should have maximum 100 symbols',
        control: registrationForm.controls['name']
      }"></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-8">
    <label class="form-label fw-bolder text-dark fs-6">البريد الإلكتروني</label>
    <input class="form-control bg-transparent" type="email" placeholder="Email" name="email" formControlName="email"
    style="height: 45px;"
      autocomplete="off" [ngClass]="{
        'is-invalid': registrationForm.controls['email'].invalid,
        'is-valid': registrationForm.controls['email'].valid
      }" />
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Email is required',
        control: registrationForm.controls['email']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'email',
        message: 'Email is invalid',
        control: registrationForm.controls['email']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Email should have at least 3 symbols',
        control: registrationForm.controls['email']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Email should have maximum 360 symbols',
        control: registrationForm.controls['email']
      }"></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-8">
    <label class="form-label fw-bolder text-dark fs-6">الرقم السري</label>
    <input class="form-control bg-transparent" type="password" placeholder="Password" name="password"   style="height: 45px;"
      formControlName="password" autocomplete="off" [ngClass]="{
        'is-invalid': registrationForm.controls['password'].invalid,
        'is-valid': registrationForm.controls['password'].valid
      }" />
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Password is required',
        control: registrationForm.controls['password']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Password should have at least 3 symbols',
        control: registrationForm.controls['password']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Password should have maximum 100 symbols',
        control: registrationForm.controls['password']
      }"></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-8">
    <label class="form-label fw-bolder text-dark fs-6">تأكيد الرقم السري</label>
    <input class="form-control bg-transparent" type="password" placeholder="Confirm password" name="cPassword"   style="height: 45px;"
      autocomplete="off" formControlName="cPassword" [ngClass]="{
        'is-invalid': registrationForm.controls['cPassword'].invalid,
        'is-valid': registrationForm.controls['cPassword'].valid
      }" />
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Confirm Password is required',
        control: registrationForm.controls['cPassword']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Confirm Password should have at least 3 symbols',
        control: registrationForm.controls['cPassword']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Confirm Password should have maximum 100 symbols',
        control: registrationForm.controls['cPassword']
      }"></ng-container>
    <ng-container *ngIf="
        registrationForm.controls['cPassword'].errors &&
        registrationForm.controls['cPassword'].errors.ConfirmPassword
      ">
      <div class="fv-plugins-message-container">
        <div class="fv-help-block">
        الرقم السري غير متطابق
        </div>
      </div>
    </ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->

  <!--end::Form group-->

  <!--begin::Form group-->
  <!-- <div class="d-grid mb-10">
    <button type="submit" id="kt_sign_up_submit" (click)="submit()" [disabled]="
        registrationForm.invalid
      " class="btn btn-primary">
      <ng-container *ngIf="(isLoading$ | async) === false">
        <span class="indicator-label">تسجيل</span>
      </ng-container>
      <ng-container *ngIf="isLoading$ | async">
        <span class="indicator-progress" [style.display]="'block'">
        جاري التسجيل...
          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
      </ng-container>
    </button>
  </div> -->

  <div class="d-grid mb-10">
    <button type="button" id="kt_sign_up_submit" (click)="submit()" [disabled]="registrationForm.invalid" class="btn btn-primary"
    style="width: 100%;"
    >
      <ng-container >
        <span class="indicator-label">تسجيل</span>
      </ng-container>
      <ng-container *ngIf="isLoading$ | async">
        <span class="indicator-progress" [style.display]="'block'">
        جاري التسجيل...
          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
      </ng-container>
    </button>
  </div>

  <!--end::Form group-->

  <!--begin::Sign up-->
  <div class="text-gray-500 text-center fw-semibold fs-6">
   لدي حساب مسبق

    <a routerLink="/auth/login" class="link-primary fw-semibold">
    تسجيل الدخول
    </a>
  </div>
  <!--end::Sign up-->

</form>

<ng-template #formError let-control="control" let-message="message" let-validation="validation">
  <ng-container *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        <span role="alert">
          {{ message }}
        </span>
      </div>
    </div>
  </ng-container>
</ng-template>
